var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticationPana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-46",
    d: "M107,416.2c80.7,48.76,211.53,48.76,292.22,0s80.69-127.83,0-176.59-211.52-48.76-292.22,0S26.31,367.43,107,416.2Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-46",
    d: "M406.75,361c7.38,4.46,19.34,4.46,26.72,0s7.37-11.68,0-16.14-19.34-4.46-26.72,0S399.38,356.52,406.75,361Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.6,52.44l55.27,31.92a4.09,4.09,0,0,1,1.85,3.2V239.5a4.09,4.09,0,0,1-1.85,3.2L315.6,274.62a4.09,4.09,0,0,1-3.7,0L256.63,242.7a4.07,4.07,0,0,1-1.85-3.2V87.56a4.09,4.09,0,0,1,1.85-3.2L311.9,52.44A4.15,4.15,0,0,1,315.6,52.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,87.56V239.5a4.1,4.1,0,0,0,1.84,3.2l55.28,31.92a3.72,3.72,0,0,0,1.85.44V118.84a3.83,3.83,0,0,1-1.85-.44L256.62,86.49l-.5-.42-.66-.55A3.85,3.85,0,0,0,254.78,87.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,102.51l-41.4,23.9a4.1,4.1,0,0,0-1.85,3.21v15.75c0,1.18.82,1.66,1.84,1.07l41.4-23.9a4.09,4.09,0,0,0,1.85-3.2V103.58C365.78,102.4,365,101.92,363.93,102.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,109.46a4,4,0,0,1-1.85,3.07L326,132.42c-1,.59-1.85.17-1.85-.93a4,4,0,0,1,1.85-3.07l34.46-19.9C361.48,107.93,362.31,108.35,362.31,109.46Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,117.47a4,4,0,0,1-1.85,3.07L326,140.43c-1,.59-1.85.17-1.85-.93a4,4,0,0,1,1.85-3.07l34.46-19.9C361.48,115.94,362.31,116.36,362.31,117.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,116.53l-19,11v4l19-11a4,4,0,0,0,1.85-3.07C362.31,116.36,361.48,115.94,360.46,116.53Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,130.55l-41.4,23.9a4.1,4.1,0,0,0-1.85,3.2v15.76c0,1.18.82,1.66,1.84,1.07l41.4-23.9a4.09,4.09,0,0,0,1.85-3.2V131.62C365.78,130.44,365,130,363.93,130.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,137.49a4,4,0,0,1-1.85,3.08L326,160.46c-1,.59-1.85.17-1.85-.93a4,4,0,0,1,1.85-3.08l34.46-19.89C361.48,136,362.31,136.39,362.31,137.49Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,145.51a4,4,0,0,1-1.85,3.07L326,168.47c-1,.59-1.85.17-1.85-.93a4,4,0,0,1,1.85-3.07l34.46-19.9C361.48,144,362.31,144.4,362.31,145.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,144.57l-29.37,17v4l29.37-16.95a4,4,0,0,0,1.85-3.07C362.31,144.4,361.48,144,360.46,144.57Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,158.59l-41.4,23.9a4.09,4.09,0,0,0-1.85,3.2v15.76c0,1.18.82,1.66,1.84,1.07l41.4-23.9a4.1,4.1,0,0,0,1.85-3.21V159.66C365.78,158.48,365,158,363.93,158.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,165.53a4,4,0,0,1-1.85,3.07L326,188.5c-1,.59-1.85.17-1.85-.94a4,4,0,0,1,1.85-3.07l34.46-19.89C361.48,164,362.31,164.43,362.31,165.53Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,173.54a4,4,0,0,1-1.85,3.07L326,196.51c-1,.59-1.85.17-1.85-.94A4,4,0,0,1,326,192.5l34.46-19.89C361.48,172,362.31,172.44,362.31,173.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,172.61l-12,6.94v4l12-6.95a4,4,0,0,0,1.85-3.07C362.31,172.44,361.48,172,360.46,172.61Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,186.63l-41.4,23.9a4.09,4.09,0,0,0-1.85,3.2v15.76c0,1.18.82,1.66,1.84,1.07l41.4-23.9a4.1,4.1,0,0,0,1.85-3.21V187.7C365.78,186.52,365,186,363.93,186.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,193.57a4,4,0,0,1-1.85,3.07L326,216.54c-1,.59-1.85.17-1.85-.94a4,4,0,0,1,1.85-3.07l34.46-19.89C361.48,192.05,362.31,192.47,362.31,193.57Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,201.58a4,4,0,0,1-1.85,3.07L326,224.55c-1,.59-1.85.17-1.85-.94a4,4,0,0,1,1.85-3.07l34.46-19.89C361.48,200.06,362.31,200.48,362.31,201.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,200.65l-19,10.95v4l19-10.95a4,4,0,0,0,1.85-3.07C362.31,200.48,361.48,200.06,360.46,200.65Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,214.67l-41.4,23.9a4.09,4.09,0,0,0-1.85,3.2v15.76c0,1.18.82,1.65,1.84,1.06l41.4-23.9a4.09,4.09,0,0,0,1.85-3.2V215.73C365.78,214.55,365,214.08,363.93,214.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,221.61a4,4,0,0,1-1.85,3.07L326,244.58c-1,.58-1.85.17-1.85-.94a4,4,0,0,1,1.85-3.07l34.46-19.9C361.48,220.09,362.31,220.5,362.31,221.61Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,229.62a4,4,0,0,1-1.85,3.07L326,252.59c-1,.59-1.85.17-1.85-.94a4,4,0,0,1,1.85-3.07l34.46-19.89C361.48,228.1,362.31,228.51,362.31,229.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,228.69l-25.9,14.95v4l25.9-15a4,4,0,0,0,1.85-3.07C362.31,228.51,361.48,228.1,360.46,228.69Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,128.49c-1.92-1.11-3.47-.1-3.47,2.26v91.61a8,8,0,0,0,3.47,6.28c1.91,1.11,3.46.1,3.46-2.26V134.77A8,8,0,0,0,305.08,128.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,226.61a4,4,0,0,1-1.74-3.14V131.61c0-1.18.78-1.69,1.74-1.13a4,4,0,0,1,1.73,3.13v91.87C306.81,226.65,306,227.16,305.08,226.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,226.61a4,4,0,0,1-1.74-3.14V179.55l3.47,2v43.92C306.81,226.65,306,227.16,305.08,226.61Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,122.48c-1.92-1.11-3.47-.1-3.47,2.26v91.61a7.94,7.94,0,0,0,3.47,6.28c1.91,1.11,3.47.1,3.47-2.26V128.76A8,8,0,0,0,294.67,122.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,220.6a4,4,0,0,1-1.74-3.14V125.6c0-1.18.78-1.68,1.74-1.13a4,4,0,0,1,1.73,3.14v91.86C296.4,220.65,295.63,221.15,294.67,220.6Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,116.48c-1.91-1.12-3.47-.1-3.47,2.25v91.61a8,8,0,0,0,3.47,6.28c1.92,1.11,3.47.1,3.47-2.26v-91.6A7.94,7.94,0,0,0,284.26,116.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,214.59a3.94,3.94,0,0,1-1.73-3.13V119.59c0-1.17.77-1.68,1.73-1.13A4,4,0,0,1,286,121.6v91.86C286,214.64,285.22,215.15,284.26,214.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,214.59a3.94,3.94,0,0,1-1.73-3.13v-71l3.47,2v71C286,214.64,285.22,215.15,284.26,214.59Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,110.47c-1.92-1.11-3.47-.1-3.47,2.26v91.6a7.94,7.94,0,0,0,3.47,6.28c1.91,1.11,3.46.1,3.46-2.26v-91.6A8,8,0,0,0,273.86,110.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,208.58a4,4,0,0,1-1.74-3.13V113.59c0-1.18.78-1.69,1.74-1.14a4,4,0,0,1,1.73,3.14v91.86C275.59,208.63,274.81,209.14,273.86,208.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,208.58a4,4,0,0,1-1.74-3.13V189.94l3.47,2v15.5C275.59,208.63,274.81,209.14,273.86,208.58Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.45,104.46c-1.92-1.11-3.47-.1-3.47,2.26v91.6a7.94,7.94,0,0,0,3.47,6.28c1.91,1.12,3.47.1,3.47-2.25V110.74A8,8,0,0,0,263.45,104.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.45,202.58a4,4,0,0,1-1.74-3.14V107.58c0-1.18.78-1.69,1.74-1.13a3.94,3.94,0,0,1,1.73,3.13v91.86C265.18,202.62,264.41,203.13,263.45,202.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.45,202.58a4,4,0,0,1-1.74-3.14V151.51l3.47,2v47.92C265.18,202.62,264.41,203.13,263.45,202.58Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,239.78l-45.6-26.33c-.82-.47-1.48-.09-1.48.86v16.61a3.26,3.26,0,0,0,1.48,2.56l45.6,26.33c.82.47,1.48.09,1.48-.85V242.34A3.26,3.26,0,0,0,307.06,239.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,244.71c0,1.1-.83,1.52-1.85.93l-38.16-22a4,4,0,0,1-1.85-3.07c0-1.11.83-1.53,1.85-.94l38.16,22A4,4,0,0,1,305.19,244.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,244.71c0,1.1-.83,1.52-1.85.93l-27.75-16v-4l27.75,16A4,4,0,0,1,305.19,244.71Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,252.72c0,1.1-.83,1.52-1.85.93l-38.16-22a4,4,0,0,1-1.85-3.07c0-1.11.83-1.53,1.85-.94l38.16,22A4,4,0,0,1,305.19,252.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,252.72c0,1.1-.83,1.52-1.85.93l-10.41-6v-4l10.41,6A4,4,0,0,1,305.19,252.72Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.63,84.36,311.9,52.44a4.15,4.15,0,0,1,3.7,0l55.27,31.92a1.12,1.12,0,0,1,0,2.13L315.6,118.4a4.09,4.09,0,0,1-3.7,0L256.63,86.49A1.12,1.12,0,0,1,256.63,84.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,110.82l42.87-24.76a2.42,2.42,0,0,0,1.11-1.92V82.7a2.42,2.42,0,0,0-1.11-1.92L314.86,56a2.48,2.48,0,0,0-2.22,0L269.76,80.78a2.45,2.45,0,0,0-1.11,1.92v1.44a2.45,2.45,0,0,0,1.11,1.92l42.88,24.76A2.48,2.48,0,0,0,314.86,110.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.73,82.06l-42.87,24.75a2.42,2.42,0,0,1-2.22,0L269.76,82.06a.68.68,0,0,1,0-1.28l42.88-23.9a2.42,2.42,0,0,1,2.22,0l42.87,23.9A.67.67,0,0,1,357.73,82.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75,107.08v4a2.25,2.25,0,0,0,1.11-.26l42.87-24.76a2.42,2.42,0,0,0,1.11-1.92V82.7a2.46,2.46,0,0,0-.9-1.78c.4.35.33.83-.21,1.14l-42.87,24.75A2.25,2.25,0,0,1,313.75,107.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,98.8l29-16.74A2.45,2.45,0,0,0,345,80.14V78.69a2.48,2.48,0,0,0-1.11-1.92L325.26,66a7.45,7.45,0,0,1-1.87-1.67l-8.88-12a1.46,1.46,0,0,0-1.87-.39l-29,16.74a2.44,2.44,0,0,0-1.11,1.92v9.46a2.45,2.45,0,0,0,1.11,1.92l29,16.74A2.42,2.42,0,0,0,314.86,98.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.64,94.8,294,84.06a6.69,6.69,0,0,1-1-.72,6.52,6.52,0,0,1-.9-1l-8.88-12a1.11,1.11,0,0,1,.35-1.67l29-16.74a1.46,1.46,0,0,1,1.87.39l8.88,12a6.9,6.9,0,0,0,1.72,1.73l18.75,10.67a.68.68,0,0,1,0,1.28l-29,16.75A2.48,2.48,0,0,1,312.64,94.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,68.76l29-16.74a1.46,1.46,0,0,1,1.87.39l8.88,12a6.57,6.57,0,0,0,.91.94s-31.21,18-31.22,18a6.12,6.12,0,0,1-.91-1l-8.88-12A1.11,1.11,0,0,1,283.64,68.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,77.07a2.84,2.84,0,0,0-2.6,0c-.72.41-.72,1.08,0,1.5a2.9,2.9,0,0,0,2.6,0C337.54,78.15,337.54,77.48,336.82,77.07Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,80.07a2.9,2.9,0,0,0-2.6,0c-.72.42-.72,1.09,0,1.5a2.84,2.84,0,0,0,2.6,0C332.34,81.16,332.34,80.49,331.62,80.07Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42,83.07a2.92,2.92,0,0,0-2.61,0,.8.8,0,0,0,0,1.51,2.92,2.92,0,0,0,2.61,0A.8.8,0,0,0,326.42,83.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.21,86.08a2.84,2.84,0,0,0-2.6,0,.79.79,0,0,0,0,1.5,2.84,2.84,0,0,0,2.6,0A.79.79,0,0,0,321.21,86.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,74.81a2.9,2.9,0,0,0-2.6,0,.8.8,0,0,0,0,1.51,2.9,2.9,0,0,0,2.6,0A.8.8,0,0,0,332.92,74.81Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,77.82a2.86,2.86,0,0,0-2.61,0,.79.79,0,0,0,0,1.5,2.92,2.92,0,0,0,2.61,0A.79.79,0,0,0,327.72,77.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.21,
    cy: 81.57,
    rx: 1.84,
    ry: 1.06,
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,83.83a2.84,2.84,0,0,0-2.6,0c-.72.41-.72,1.08,0,1.5a2.9,2.9,0,0,0,2.6,0C318,84.91,318,84.24,317.31,83.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,72.56a2.9,2.9,0,0,0-2.6,0c-.72.42-.72,1.09,0,1.5a2.84,2.84,0,0,0,2.6,0C329.74,73.65,329.74,73,329,72.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,75.56a2.9,2.9,0,0,0-2.6,0,.8.8,0,0,0,0,1.51,2.9,2.9,0,0,0,2.6,0A.8.8,0,0,0,323.81,75.56Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,78.57a2.84,2.84,0,0,0-2.6,0,.79.79,0,0,0,0,1.5,2.9,2.9,0,0,0,2.6,0A.79.79,0,0,0,318.61,78.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,89a2.9,2.9,0,0,0-2.6,0c-.72.42-.72,1.09,0,1.5a2.84,2.84,0,0,0,2.6,0C316.7,90.11,316.7,89.44,316,89Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.08,86.77a2.84,2.84,0,0,0-2.6,0,.79.79,0,0,0,0,1.5,2.84,2.84,0,0,0,2.6,0A.79.79,0,0,0,312.08,86.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,81.57a2.9,2.9,0,0,0-2.6,0,.8.8,0,0,0,0,1.51,2.9,2.9,0,0,0,2.6,0A.8.8,0,0,0,313.41,81.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.12,70.31a2.86,2.86,0,0,0-2.61,0,.79.79,0,0,0,0,1.5,2.86,2.86,0,0,0,2.61,0A.79.79,0,0,0,325.12,70.31Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.61,
    cy: 74.06,
    rx: 1.84,
    ry: 1.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,76.32a2.84,2.84,0,0,0-2.6,0c-.72.41-.72,1.08,0,1.5a2.9,2.9,0,0,0,2.6,0C315.43,77.4,315.43,76.73,314.71,76.32Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.51,79.32a2.92,2.92,0,0,0-2.61,0,.79.79,0,0,0,0,1.5,2.86,2.86,0,0,0,2.61,0A.79.79,0,0,0,309.51,79.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18,84.52a2.86,2.86,0,0,0-2.61,0,.79.79,0,0,0,0,1.5,2.86,2.86,0,0,0,2.61,0A.79.79,0,0,0,308.18,84.52Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,82.27a2.84,2.84,0,0,0-2.6,0c-.72.41-.72,1.08,0,1.5a2.9,2.9,0,0,0,2.6,0C305,83.35,305,82.68,304.27,82.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.69,95.06v4a2.29,2.29,0,0,0,1.17-.26l29-16.74A2.47,2.47,0,0,0,345,80.13V78.69a2.47,2.47,0,0,0-.91-1.77c.4.35.33.82-.2,1.13l-29,16.75A2.29,2.29,0,0,1,313.69,95.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,63.87l0,0a1,1,0,0,0-1.25-.26L293.05,78.15a.73.73,0,0,0-.23,1.11l0,0a1,1,0,0,0,1.25.26L319.32,65A.74.74,0,0,0,319.56,63.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,63.87l0,0a1,1,0,0,0-1.25-.26L299.52,74.41l1.05,1.4L319.32,65A.74.74,0,0,0,319.56,63.87Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,61.07l0,0a1,1,0,0,0-1.24-.26L291,75.34a.75.75,0,0,0-.23,1.12l0,0a1,1,0,0,0,1.25.26l25.23-14.57A.74.74,0,0,0,317.47,61.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,61.07l0,0a1,1,0,0,0-1.24-.26l-6.28,3.62L311,65.8l6.27-3.62A.74.74,0,0,0,317.47,61.07Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,58.27l0,0a1,1,0,0,0-1.25-.26L288.87,72.54a.75.75,0,0,0-.23,1.12l0,0a1,1,0,0,0,1.25.26l25.23-14.57A.74.74,0,0,0,315.38,58.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,58.27l0,0a1,1,0,0,0-1.25-.26L301,65.54l1.05,1.4,13.14-7.56A.74.74,0,0,0,315.38,58.27Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,55.47l0,0a1,1,0,0,0-1.25-.26L286.79,69.74a.75.75,0,0,0-.23,1.12l0,0a1,1,0,0,0,1.25.26l25.23-14.57A.74.74,0,0,0,313.3,55.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,55.47l0,0a1,1,0,0,0-1.25-.26L289.11,68.4l1.05,1.4,22.9-13.22A.74.74,0,0,0,313.3,55.47Z",
    style: {
      fill: "#2A272A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,242.14a.5.5,0,0,1,.46.07,1.57,1.57,0,0,1,.7,1.22.53.53,0,0,1-.16.42h0l-.08.05-30.06,17.35-2-1.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,244.49a.49.49,0,0,1,.46.06,1.57,1.57,0,0,1,.71,1.22.52.52,0,0,1-.17.43h0l-.08.05L239.26,263.6l-2-1.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,246.83a.5.5,0,0,1,.46.07,1.54,1.54,0,0,1,.7,1.21.54.54,0,0,1-.16.43h0l-.09.05-30.05,17.35-2-1.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,249.17a.55.55,0,0,1,.47.07,1.57,1.57,0,0,1,.7,1.22.51.51,0,0,1-.16.42h0l-.08.05-30.06,17.35-2-1.14Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,347.56a8.79,8.79,0,0,0,4.1,6.81l115,66.37a9.07,9.07,0,0,0,8.21,0l157.28-90.81a7.71,7.71,0,0,0,0-13.63L240.63,249.93a9.11,9.11,0,0,0-8.2,0L75.14,340.74A8.79,8.79,0,0,0,71,347.56Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,412.84v8.88a8.44,8.44,0,0,1-4.11-1L75.14,354.37A7.68,7.68,0,0,1,74.72,341c-1.84,1.32-1.7,3.25.42,4.47l115,66.37A8.33,8.33,0,0,0,194.2,412.84Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,340.89a8.79,8.79,0,0,1-3.85-7V196.75a9.07,9.07,0,0,1,4.1-7.1L224.73,98.84a7.71,7.71,0,0,1,11.8,6.81V242.83a9.05,9.05,0,0,1-4.1,7.1L75.14,340.74A8.78,8.78,0,0,1,67.19,340.89Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,341a8.83,8.83,0,0,1-7.46-.1,8.8,8.8,0,0,1-3.85-7V196.75a8.37,8.37,0,0,1,1.2-4l7.7,4.44h0a8.38,8.38,0,0,0-1.21,4V338.38C71,340.8,72.62,341.89,74.65,341Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,201.2V338.38c0,2.61,1.83,3.67,4.1,2.36l157.29-90.81a9.05,9.05,0,0,0,4.1-7.1V105.65c0-2.62-1.84-3.68-4.1-2.37L75.14,194.09A9.06,9.06,0,0,0,71,201.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14,345.48l115,66.37a9.07,9.07,0,0,0,8.21,0L355.58,321c2.27-1.31,2.27-3.43,0-4.74L240.63,249.93a9.11,9.11,0,0,0-8.2,0L75.14,340.74C72.87,342.05,72.87,344.17,75.14,345.48Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14,345.48l115,66.37a9.07,9.07,0,0,0,8.21,0L355.58,321c2.27-1.31,2.27-3.43,0-4.74L240.63,249.93a9.11,9.11,0,0,0-8.2,0L75.14,340.74C72.87,342.05,72.87,344.17,75.14,345.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,201.7,229,114.17c1.36-.78,2.46-.14,2.46,1.43V234.35a5.44,5.44,0,0,1-2.46,4.26L77.35,326.14c-1.36.78-2.47.15-2.47-1.42V206A5.47,5.47,0,0,1,77.35,201.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,183.17l-1,27.42c0,11.29-7.09,31.68-21.68,46.75a7.2,7.2,0,0,1-3.8,1.9c-.74.07-1.45.1-2.15.1a17.7,17.7,0,0,1-8.92-2.26l-.09-.05-.17-.11C133.1,253,129.9,245,129.9,237.46l-1-26.21a2.77,2.77,0,0,1,.74-1.91,3.79,3.79,0,0,1,1.31-1c6.68-3,16.69-14.79,21.39-26.46.34-.83.84-1.1,1.4-.84h0l.08.05a2,2,0,0,1,.51.41h0l.09.11c5,5.8,14.79,5.79,21.33.79.5-.38.91-.5,1.19-.38l0,0h0C177.28,182.22,177.42,182.58,177.4,183.17Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.17,181a1.38,1.38,0,0,0-.79.88c-4.7,11.67-14.71,23.5-21.39,26.46a3.79,3.79,0,0,0-1.31,1,2.77,2.77,0,0,0-.74,1.91l1,26.21c0,7.57,3.2,15.57,9.72,19.46l.17.11.09.05a17.7,17.7,0,0,0,8.92,2.26c.7,0,1.41,0,2.15-.1a6.18,6.18,0,0,0,2.22-.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.48,341.93l146-84.29a4.55,4.55,0,0,1,4.1,0l7.47,4.31a1.25,1.25,0,0,1,0,2.37L100,348.6a4.55,4.55,0,0,1-4.1,0l-7.45-4.3A1.25,1.25,0,0,1,88.48,341.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.73,353l146-84.29a4.49,4.49,0,0,1,4.1,0l45.93,26.52a1.25,1.25,0,0,1,0,2.37L157.93,381.81a4.58,4.58,0,0,1-4.11,0L107.73,355.4A1.24,1.24,0,0,1,107.73,353Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,306.67l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.19.3,0,.42l5.29,3.06A.82.82,0,0,0,238.6,306.67Zm-9-10.48L225,298.82c-.2.12-.19.3,0,.43l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.79.79,0,0,0,229.58,296.19Zm-14.77,8.52-7.74,4.47c-.19.11-.18.3,0,.42l5.29,3a.8.8,0,0,0,.72,0l7.74-4.47c.19-.11.18-.3,0-.42l-5.28-3A.82.82,0,0,0,214.81,304.71ZM222.9,300l-4.58,2.64c-.19.11-.18.3,0,.42l5.29,3a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.82.82,0,0,0,222.9,300ZM205,310.4,200.39,313c-.19.12-.18.31,0,.43l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3A.79.79,0,0,0,205,310.4Zm-6.68,3.85-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42L199,314.27A.82.82,0,0,0,198.28,314.25Zm20.79,12.41,4.58-2.64c.19-.11.18-.3,0-.42l-5.29-3.05a.79.79,0,0,0-.73,0L213,323.18c-.19.11-.18.3,0,.42l5.28,3A.82.82,0,0,0,219.07,326.66Zm-6.68,3.86,4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3a.82.82,0,0,0-.73,0L206.35,327c-.19.11-.18.3,0,.42l5.28,3.06A.82.82,0,0,0,212.39,330.52Zm-6.68,3.86,4.57-2.64c.2-.11.19-.3,0-.42L205,328.27a.79.79,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05A.82.82,0,0,0,205.71,334.38ZM199,338.23l4.57-2.63c.2-.12.18-.31,0-.43l-5.29-3.05a.82.82,0,0,0-.73,0L193,334.75c-.19.11-.18.3,0,.42l5.28,3.05A.79.79,0,0,0,199,338.23Zm32.89-27.7,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0L225.88,307c-.2.11-.19.3,0,.42l5.29,3.05A.82.82,0,0,0,231.92,310.53Zm-6.17,12.28,10.2-5.89c.2-.11.18-.3,0-.42l-12.84-7.41a.82.82,0,0,0-.73,0l-5.27,3.05c-.2.11-.19.3,0,.42l6.8,3.92c.21.12.22.31,0,.42l-4.22,2.44c-.19.11-.18.3,0,.42l5.29,3.05A.8.8,0,0,0,225.75,322.81Zm-34.15-4.7L187,320.75c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05A.79.79,0,0,0,191.6,318.11ZM184.92,322l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05a.79.79,0,0,0,.73,0l4.57-2.63c.2-.12.18-.31,0-.43l-5.29-3A.82.82,0,0,0,184.92,322Zm-33.38,43.25a.79.79,0,0,0,.73,0l4.57-2.63c.19-.12.18-.31,0-.43l-5.29-3.05a.79.79,0,0,0-.72,0l-4.58,2.64c-.19.11-.18.3,0,.42Zm-20.07-12.39-4.57,2.63c-.19.12-.18.3,0,.43l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05A.79.79,0,0,0,131.47,352.83Zm10.76,9.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.19.3,0,.42Zm21.1,5.68,4.57-2.63c.2-.12.19-.31,0-.43l-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05A.79.79,0,0,0,163.33,367.56Zm-7.41,3.85a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.12-.18.3,0,.42ZM138.15,349l-4.57,2.64c-.19.11-.18.3,0,.42l5.29,3.05a.77.77,0,0,0,.72,0l4.58-2.63c.19-.12.18-.3,0-.43l-5.29-3A.82.82,0,0,0,138.15,349Zm33.41-19.29L167,332.32c-.2.11-.18.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.82.82,0,0,0,171.56,329.68Zm-26.72,15.43-4.58,2.64c-.19.11-.18.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.29-3.05A.8.8,0,0,0,144.84,345.11Zm33.4-19.29-4.57,2.64c-.2.12-.18.3,0,.42l5.29,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42L179,325.84A.82.82,0,0,0,178.24,325.82Zm-13.36,7.72-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3a.82.82,0,0,0,.73,0l4.57-2.64c.19-.12.18-.3,0-.42l-5.28-3.06A.82.82,0,0,0,164.88,333.54Zm-6.68,3.86L153.63,340c-.2.11-.19.3,0,.42l5.29,3.05a.79.79,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3A.79.79,0,0,0,158.2,337.4Zm-6.68,3.85L147,343.89c-.2.11-.19.3,0,.42l5.29,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.82.82,0,0,0,151.52,341.25Zm34.15,4.7,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.29,3.05A.82.82,0,0,0,185.67,346Zm58.68-58.29-4.58,2.64c-.19.11-.18.3,0,.42l5.29,3a.82.82,0,0,0,.73,0l4.57-2.64c.19-.12.18-.3,0-.42l-5.29-3.06A.79.79,0,0,0,244.35,287.66Zm-8.09,4.67L231.69,295c-.2.11-.19.3,0,.42l5.29,3.05a.79.79,0,0,0,.73,0l4.57-2.63c.19-.12.18-.31,0-.43L237,292.34A.82.82,0,0,0,236.26,292.33ZM251,283.8l-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.82.82,0,0,0,251,283.8Zm-34.58,35.66,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3a.82.82,0,0,0-.73,0L210.4,316c-.19.12-.18.3,0,.42l5.29,3.06A.82.82,0,0,0,216.45,319.46Zm42-39.5a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.19.3,0,.42l5.29,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42Zm-66.09,62.13,4.57-2.64c.2-.11.18-.3,0-.42l-5.29-3a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.18.3,0,.42l5.28,3.06A.82.82,0,0,0,192.35,342.09Zm81.93-47.3,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.29,3A.79.79,0,0,0,274.28,294.79Zm-14.23-.5,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0L254,290.8c-.2.11-.19.3,0,.42l5.29,3A.82.82,0,0,0,260.05,294.29Zm5.94-10a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.19.3,0,.42l5.29,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42Zm1.4-.81,12.84,7.41a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42l-12.84-7.41a.79.79,0,0,0-.73,0l-4.57,2.64C267.17,283.2,267.19,283.39,267.39,283.51ZM251.9,292l-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3.05a.79.79,0,0,0,.73,0l4.57-2.63c.19-.12.18-.3,0-.43L252.63,292A.82.82,0,0,0,251.9,292Zm-50.29,29L197,323.69c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.12.19-.3,0-.42l-5.29-3.06A.82.82,0,0,0,201.61,321.05Zm65.26-22.42a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42Zm-58.58,18.56-4.57,2.64c-.19.11-.18.3,0,.42L209,323.3a.8.8,0,0,0,.72,0l4.58-2.64c.19-.11.18-.3,0-.42L209,317.21A.82.82,0,0,0,208.29,317.19Zm-50.07,44.17a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42Zm-10.05-9.45-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3a.79.79,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.79.79,0,0,0,148.17,351.91Zm17.46,5.61,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3a.82.82,0,0,0-.73,0L159.59,354c-.2.11-.19.3,0,.42l5.29,3.06A.82.82,0,0,0,165.63,357.52Zm6.68-3.86,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3A.79.79,0,0,0,172.31,353.66Zm6.68-3.85,4.57-2.64c.19-.12.18-.3,0-.42l-5.28-3.06a.82.82,0,0,0-.73,0L173,346.32c-.2.11-.19.3,0,.42l5.29,3.05A.82.82,0,0,0,179,349.81Zm-24.14-1.76-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.12.18-.3,0-.42l-5.28-3.06A.82.82,0,0,0,154.85,348.05Zm6.68-3.86L157,346.83c-.2.11-.19.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05A.82.82,0,0,0,161.53,344.19Zm26.72-15.43-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42L189,328.78A.82.82,0,0,0,188.25,328.76Zm-6.68,3.86L177,335.26c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05A.79.79,0,0,0,181.57,332.62Zm13.36-7.71-4.57,2.63c-.19.12-.18.31,0,.43l5.28,3a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05A.79.79,0,0,0,194.93,324.91Zm-26.72,15.42L163.64,343c-.2.12-.18.3,0,.42l5.29,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3A.82.82,0,0,0,168.21,340.33Zm6.68-3.85-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3a.79.79,0,0,0,.73,0l4.57-2.63c.2-.12.18-.31,0-.43l-5.29-3.05A.82.82,0,0,0,174.89,336.48ZM170,363.71l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3a.79.79,0,0,0-.73,0L164,360.22c-.19.11-.18.3,0,.42l5.28,3.05A.82.82,0,0,0,170,363.71Zm-39.2-4-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64C131,360.06,131,359.87,130.81,359.75Zm10,2.94-5.29-3.05a.8.8,0,0,0-.72,0l-7,4.06c-.19.11-.18.3,0,.42l5.28,3a.82.82,0,0,0,.73,0l7-4.06C141,363,141,362.81,140.82,362.69Zm-18.12-8.84-5.29-3.05a.82.82,0,0,0-.73,0L111.06,354c-.2.11-.19.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l5.62-3.25C122.92,354.16,122.91,354,122.7,353.85Zm4.31-2.49a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42L127,345.26a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42ZM150.13,366l-5.29-3a.79.79,0,0,0-.73,0L135.32,368c-.19.11-.18.3,0,.42l5.29,3.05a.8.8,0,0,0,.72,0l8.8-5.08C150.35,366.34,150.34,366.15,150.13,366Zm4.39,6.19-5.29-3.05a.82.82,0,0,0-.73,0l-5.63,3.25c-.19.11-.18.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l5.62-3.25C154.74,372.53,154.72,372.34,154.52,372.22Zm22.16-49.54a.82.82,0,0,0,.73,0l4.57-2.64c.2-.12.19-.3,0-.42l-5.29-3.06a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm-13.36,7.71a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0L158,326.92c-.19.11-.18.3,0,.42ZM133.69,347.5a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.06a.82.82,0,0,0-.73,0L128.38,344c-.19.11-.18.3,0,.42Zm36.31-21a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42L170,320.44a.79.79,0,0,0-.73,0l-4.57,2.63c-.19.12-.18.31,0,.43Zm-13.36,7.71a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42l-5.29-3.06a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm1.55,38.46a.82.82,0,0,0-.73,0l-7,4.06c-.2.11-.19.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l7-4.06c.19-.11.18-.3,0-.42Zm-11.14-32.92a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42L147,333.69a.79.79,0,0,0-.73,0l-4.57,2.63c-.19.12-.18.3,0,.43Zm-6.68,3.85a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42ZM282,301.25a.82.82,0,0,0-.73,0L270,307.74c-.2.11-.18.3,0,.42l5.29,3a.79.79,0,0,0,.73,0l11.25-6.49c.2-.11.18-.3,0-.42Zm-14.77,8.53a.79.79,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.05a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42Zm-90.5,50.07,4.58-2.64c.19-.11.18-.3,0-.42L176,353.74a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.06A.82.82,0,0,0,176.69,359.85Zm77.14-42.35a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.28,3a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42Zm34.81-20.1a.82.82,0,0,0-.73,0L283.34,300c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42Zm12-.81-12.84-7.41a.79.79,0,0,0-.73,0l-4.57,2.63c-.19.12-.18.31,0,.43l12.83,7.41a.82.82,0,0,0,.73,0l4.57-2.64C300.83,296.9,300.82,296.71,300.61,296.59Zm-71.75,35.32a.8.8,0,0,0-.72,0l-5.63,3.25c-.2.11-.18.3,0,.42l5.29,3.05a.79.79,0,0,0,.73,0l5.63-3.25c.19-.11.18-.3,0-.42Zm16.88-9.75a.82.82,0,0,0-.73,0l-7,4.06c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l7-4.06c.2-.11.19-.3,0-.42Zm-32.35,18.68a.79.79,0,0,0-.73,0L175,362.55c-.19.11-.18.3,0,.42l5.28,3a.82.82,0,0,0,.73,0l37.62-21.73c.2-.11.19-.3,0-.42Zm-39.73,22.94a.79.79,0,0,0-.73,0L167.3,367c-.19.11-.18.3,0,.42l5.29,3.05a.79.79,0,0,0,.72,0l5.63-3.25c.19-.11.18-.3,0-.42Zm47.47-27.4a.79.79,0,0,0-.73,0l-5.63,3.25c-.19.11-.18.3,0,.42l5.28,3.05a.82.82,0,0,0,.73,0l5.63-3.25c.19-.11.18-.3,0-.42Zm-55.21,31.87a.82.82,0,0,0-.73,0l-5.62,3.25c-.2.11-.18.3,0,.42l5.29,3.05a.82.82,0,0,0,.73,0l5.62-3.25c.2-.11.19-.3,0-.42Zm70.68-40.81a.82.82,0,0,0-.73,0l-5.63,3.25c-.19.11-.18.3,0,.42l5.29,3a.79.79,0,0,0,.73,0l5.62-3.24c.2-.12.18-.31,0-.43Zm23.91-13.8a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.28,3.06a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42ZM275.15,303l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.29,3.05A.82.82,0,0,0,275.15,303Zm-29.87-.2,4.57-2.63c.19-.12.18-.31,0-.43l-5.28-3.05a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.29,3.05A.79.79,0,0,0,245.28,302.81ZM230.14,329l13.36-7.71c.2-.11.19-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0L224.1,325.5c-.19.12-.18.31,0,.43l5.28,3.05A.82.82,0,0,0,230.14,329Zm37.6-22.14a.79.79,0,0,0,.73,0l4.57-2.63c.19-.12.18-.31,0-.43l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42Zm-6.82-4.35,4.57-2.63c.19-.12.18-.31,0-.43l-5.28-3.05a.82.82,0,0,0-.73,0L254.88,299c-.2.11-.19.3,0,.42l5.29,3.05A.79.79,0,0,0,260.92,302.5Zm-37.46,30.35,4.57-2.64c.2-.11.18-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.28,3.05A.82.82,0,0,0,223.46,332.85ZM253,315.38a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.18-.3,0-.42L253,309.28a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.18.3,0,.42Zm-62.91,36.76,4.57-2.64c.19-.12.18-.3,0-.42L189.32,346a.82.82,0,0,0-.73,0L184,348.65c-.2.11-.19.3,0,.42l5.29,3.05A.82.82,0,0,0,190.06,352.14Zm6.68-3.86,4.57-2.64c.19-.11.18-.3,0-.42L196,342.17a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3.05A.82.82,0,0,0,196.74,348.28ZM183.37,356l4.58-2.64c.19-.11.18-.3,0-.42l-5.29-3.05a.79.79,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42l5.29,3.05A.79.79,0,0,0,183.37,356Zm26.73-15.43,4.57-2.63c.19-.12.18-.31,0-.43l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42l5.29,3.05A.79.79,0,0,0,210.1,340.56Zm-6.68,3.86,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.12-.19.3,0,.42l5.29,3.06A.82.82,0,0,0,203.42,344.42Zm13.36-7.71,4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.29,3.05A.82.82,0,0,0,216.78,336.71Zm30.56-57.06a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-1.41-.81a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm-32.87,21.21a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm13.36-7.71a.79.79,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.79.79,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm-21.52,12.42a.82.82,0,0,0,.73,0l4.58-2.64c.19-.11.18-.3,0-.42l-5.29-3a.82.82,0,0,0-.73,0L201,302.1c-.19.11-.18.3,0,.42ZM221.15,297a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.12-.18.3,0,.42ZM193,313.29a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.79.79,0,0,0-.73,0l-4.57,2.63c-.19.12-.18.31,0,.43Zm6.68-3.86a.82.82,0,0,0,.73,0l4.57-2.64c.2-.12.19-.3,0-.42l-5.29-3.06a.82.82,0,0,0-.73,0L194.32,306c-.19.11-.18.3,0,.42ZM234,287.36a.79.79,0,0,0,.73,0l4.57-2.63c.2-.12.19-.3,0-.43l-1.41-.81a.82.82,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm20-11.57a.79.79,0,0,0,.73,0l4.58-2.64c.19-.11.18-.3,0-.42l-1.41-.81a.79.79,0,0,0-.73,0l-4.57,2.63c-.19.12-.18.31,0,.43Zm11.11,6.41a.79.79,0,0,0,.73,0l4.57-2.64c.19-.11.18-.3,0-.42l-5.28-3a.79.79,0,0,0-.73,0l-4.57,2.64c-.2.11-.19.3,0,.42Zm16.7,16.95,4.57-2.64c.2-.11.18-.3,0-.42l-5.29-3a.82.82,0,0,0-.73,0l-4.57,2.64c-.2.11-.18.3,0,.42l5.28,3.05A.79.79,0,0,0,281.83,299.15ZM240.66,283.5a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-1.41-.81a.79.79,0,0,0-.73,0l-4.57,2.64c-.19.11-.18.3,0,.42Zm-54.39,33.64a.82.82,0,0,0,.73,0l4.57-2.64c.2-.11.19-.3,0-.42l-5.29-3.05a.82.82,0,0,0-.73,0L181,313.67c-.19.11-.18.3,0,.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,357.25,261,331.2a5.46,5.46,0,0,1,4.92,0l25.87,14.94c1.36.78,1.36,2.05,0,2.84l-45.11,26a5.4,5.4,0,0,1-4.92,0L215.9,360.09C214.54,359.3,214.54,358,215.9,357.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,340.88a6,6,0,0,0,1.26.54,5.48,5.48,0,0,1-1.26-.53,2.59,2.59,0,0,1-.39-.25A3.68,3.68,0,0,0,67.19,340.88Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,105c-.29-2.12-2-2.9-4.07-1.7L75.14,194.09a8.28,8.28,0,0,0-2.9,3l-7.7-4.43a8.39,8.39,0,0,1,2.9-3.06L224.73,98.83A7.68,7.68,0,0,1,236.49,105Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.37,341.27a.13.13,0,0,1,.06,0l0,0Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,323.12a8.82,8.82,0,0,1-4.1,6.81L198.3,420.74a8.43,8.43,0,0,1-4.11,1v-8.87a8.44,8.44,0,0,0,4.11-1L355.59,321c2.11-1.23,2.25-3.15.41-4.47A8.84,8.84,0,0,1,359.69,323.12Z",
    style: {
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.37,245.36h0L442,234.76h0c-.41-.22-1-.07-1.72.48-.38.28-.76.56-1.14.82l-.43.27c-.25.16-.5.33-.76.48s-.36.2-.54.31l-.67.37-.62.31-.62.3-.69.29c-.19.08-.38.17-.58.24l-.75.28-.53.19-.81.25-.48.14-.87.22-.44.1c-.3.07-.61.13-.92.18l-.38.07-1,.14-.33,0c-.34,0-.69.07-1,.09l-.27,0-1.08,0h-.22c-.37,0-.74,0-1.11,0h-.17c-.38,0-.77,0-1.15-.08h-.11l-1.19-.16h-.06l-.55-.11-11.4-6.58h0c-.84-.47-1.61-.13-2.11,1.1-6.62,16.44-20.72,33.11-30.12,37.28a4,4,0,0,0-.54.28,3.15,3.15,0,0,0-.33.22l-.15.1-.41.35,0,0c-.14.13-.27.27-.4.41h0a4,4,0,0,0-1.05,2.68l1.36,16.7c0,10.77,4.58,22.13,13.93,27.56h0l18.38,10.59h0l.13.07h0a25.86,25.86,0,0,0,15.59,3.05,10.11,10.11,0,0,0,5.35-2.68c20.56-21.23,30.55-50,30.55-65.86l1.36-18.4C460.94,246.08,460.73,245.57,460.37,245.36Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,243.93a1.18,1.18,0,0,0-1.17.06l-.2.15a2.43,2.43,0,0,0-.31.38s0,0,0,0a3.9,3.9,0,0,0-.26.54,82.6,82.6,0,0,1-6.19,12.18,97.84,97.84,0,0,1-6.83,9.83c-1.2,1.5-2.4,2.93-3.61,4.27a.1.1,0,0,1,0,.05l-1,1.11,0,0c-.35.35-.68.71-1,1.05-.17.19-.34.37-.52.54-3.86,3.88-7.64,6.78-10.87,8.21a5.23,5.23,0,0,0-1.49,1l-.37.37h0a.71.71,0,0,1-.07.09l.07-.09-18.36-10.58a.2.2,0,0,1,.06-.07.79.79,0,0,1,.12-.15l.11-.1a.94.94,0,0,1,.1-.1l.11-.1h0a3.48,3.48,0,0,1,.3-.26l.15-.1c.11-.07.22-.16.33-.22a3.08,3.08,0,0,1,.54-.28c9.4-4.17,23.51-20.84,30.12-37.28.36-.88.85-1.31,1.41-1.31a1.4,1.4,0,0,1,.7.22L420.8,240Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.37,245.36h0L442,234.76h0c-.4-.21-1-.06-1.71.48-.37.29-.76.57-1.15.83l-.42.27c-.25.16-.5.33-.76.48s-.36.2-.54.31l-.67.37c-.2.11-.41.2-.62.3l-.62.31-.7.29c-.18.09-.38.17-.57.25l-.75.27-.53.19-.82.25-.48.14-.86.22-.43.1-.93.18-.39.07c-.32.06-.64.1-1,.14l-.33,0-1,.1h-.27c-.36,0-.72,0-1.08,0h-.21c-.38,0-.75,0-1.12,0h-.16c-.39,0-.78-.05-1.16-.08l-.11,0c-.4,0-.8-.09-1.18-.15h-.06a3.26,3.26,0,0,1-.55-.12l6.84,3.94.12.07a2.67,2.67,0,0,1,.68.61h0a.86.86,0,0,1,.13.14c7,8.18,20.84,8.17,30.07,1.11.7-.53,1.28-.7,1.67-.52l.06,0h0a.9.9,0,0,1,.39.48A.91.91,0,0,0,460.37,245.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,330.58l-18.13-10.44h0c-9.34-5.44-13.93-16.8-13.93-27.57l-1.36-16.7a4.22,4.22,0,0,1,1.68-3.3,5.26,5.26,0,0,0-.63.62l18.37,10.58a3.92,3.92,0,0,0-1,2.69l1.35,16.7C394,313.83,398.5,325.09,407.68,330.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.91,246.91l-1.36,18.4c0,15.9-10,44.63-30.54,65.86a10,10,0,0,1-5.37,2.67,25.77,25.77,0,0,1-15.58-3h0l-.13-.07-.24-.15c-9.19-5.49-13.7-16.74-13.7-27.42l-1.35-16.7a3.94,3.94,0,0,1,1-2.68h0a4.25,4.25,0,0,1,.36-.37,5.17,5.17,0,0,1,1.49-1c3.24-1.44,7-4.34,10.88-8.21l.52-.54,1-1.06,0,0,1-1.11s0,0,0,0c1.22-1.35,2.42-2.78,3.62-4.28a98.35,98.35,0,0,0,6.83-9.83,82.43,82.43,0,0,0,6.18-12.17,5.67,5.67,0,0,1,.27-.55l0,0a2.33,2.33,0,0,1,.31-.37,1.3,1.3,0,0,1,.2-.15,1.12,1.12,0,0,1,1.16-.06l.13.06a2.52,2.52,0,0,1,.68.61h0l.13.15c7,8.17,20.84,8.16,30.07,1.11.69-.53,1.28-.7,1.67-.53l.05,0h0a.53.53,0,0,1,.23.19A1.92,1.92,0,0,1,460.91,246.91Z",
    style: {
      fill: "#2A272A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.11,307.26l-10.94,6.31,1.69-19.79c-1.31-.69-2.14-2.4-2.14-4.84,0-4.36,2.65-9.42,5.92-11.31s5.92.11,5.92,4.47a15,15,0,0,1-2.14,7.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.11 307.26 422.2 301.53 421.17 313.57 432.11 307.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,277.63a12.89,12.89,0,0,0-5.05,6.7l8.83,5.09h0a15,15,0,0,0,2.14-7.32C432.56,277.74,429.91,275.74,426.64,277.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.4,198.69c-3-1.76-6.86-1.56-10.49.53l-28.75,16.61A21.89,21.89,0,0,0,391,233.48V268.7h0a2.52,2.52,0,0,0,1.49,2.07,8,8,0,0,0,7.18,0,2.52,2.52,0,0,0,1.49-2.07h0V233.48a11.85,11.85,0,0,1,5.11-8.85L435,208h0v35.25h0a2.52,2.52,0,0,0,1.5,2.07,7.94,7.94,0,0,0,7.17,0,2.52,2.52,0,0,0,1.49-2.07h0V208C445.18,203.85,443.44,200.44,440.4,198.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,208v35.22a2.52,2.52,0,0,0,1.5,2.07,5.79,5.79,0,0,0,1.49.59V206.28L435,208Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationPana);
export default __webpack_public_path__ + "static/media/Authentication-pana.d7059d3dcb8869eed40fb358125c3deb.svg";
export { ForwardRef as ReactComponent };